import { useEffect, useState } from 'react';

import { useGetMeetingQuery, useOnUpdateMeetingSubscription } from '@/@generated/codegen/API';
import { captureSentry } from '@/utils/helpers/sentryHelper';

import { getMeetingStatus, MEETING_STATUS } from '../helpers/getMeetingStatus';

export default function useMeetingStatusSubscription(meetingID?: string | null) {
  const [meetingStatus, setMeetingStatus] = useState<MEETING_STATUS | null>(null);
  const getMeeting = useGetMeetingQuery({
    variables: {
      where: {
        id: meetingID,
      },
    },
    skip: !meetingID,
  });

  useOnUpdateMeetingSubscription({
    variables: {
      where: {
        id: {
          equals: meetingID,
        },
      },
    },
    skip: !meetingID,
    onData: (data) => {
      const obj = data.data?.data?.onUpdateMeeting;
      if (!obj) {
        captureSentry({
          title: 'useMeetingStatusSubscription | onData | obj is undefined',
          detail: {},
        });
        return;
      }
      setMeetingStatus(getMeetingStatus(obj));
    },
  });

  useEffect(() => {
    const meeting = getMeeting.data?.getMeeting;
    if (!meeting) return;
    setMeetingStatus(getMeetingStatus(meeting));
  }, [getMeeting.data]);

  return meetingStatus;
}
